import { memo, useState } from "react";
import { Box } from "@mui/material";

import EventManagerHeader from "./header/EventManagerHeader";
import EventManagerContent from "./EventManagerContent";

import useEventDialogs from "../hooks/useEventDialogs";

function EventManagerBody() {
  const [viewMode, setViewMode] = useState("all");
  const dialogs = useEventDialogs();

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
    >
      {/* ✅ HEADER */}
      <EventManagerHeader
        viewMode={viewMode}
        setViewMode={setViewMode}
        dialogs={dialogs}
      />

      {/* ✅ SCROLL AREA */}
      <Box
        sx={{
          flex: 1,
          overflowY: "auto",
          minHeight: 0,
          mt: "1rem",
          pb: "3rem",
        }}
      >
        <EventManagerContent viewMode={viewMode} dialogs={dialogs} />
      </Box>
    </Box>
  );
}

export default memo(EventManagerBody);
